import { useQuery } from 'react-query'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import { api } from '../../../services/api'
import { TableContainer, Text, Tooltip } from '@chakra-ui/react'
import * as T from '../../../components/Table'
import { format } from 'date-fns'
import { Filtros } from './Filtros'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'

async function getHistory({ nome_liberador, nome_usuario, data_inicio, data_final }) {
  const response = await api.get(
    `/site/v2/fluxo-liberacao/listar-historico-liberacao?nome_liberador=${nome_liberador}&nome_usuario=${nome_usuario}&data_inicio=${data_inicio}&data_final=${data_final}`
  )

  return response.data?.map((item) => {
    return {
      ...item,
      data_liberacao: format(new Date(item.data_liberacao), 'dd/MM/yyyy HH:mm') || '-',
    }
  })
}

export function HistoricoLiberacao() {
  const [searchParams, setSearchParams] = useSearchParams()
  const { register, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      nome_liberador: searchParams.get('nome_liberador') || '',
      nome_usuario: searchParams.get('nome_usuario') || '',
      data_inicio: searchParams.get('data_inicio') || '',
      data_fim: searchParams.get('data_fim') || '',
    },
  })

  function handleSearchValue(event) {
    const params = {
      nome_liberador: event.nome_liberador !== undefined ? event.nome_liberador : '',
      nome_usuario: event.nome_usuario !== undefined ? event.nome_usuario : '',
      data_inicio: event.data_inicio !== undefined ? event.data_inicio : '',
      data_fim: event.data_fim !== undefined ? event.data_fim : '',
    }

    setSearchParams(params)
    refetch()
  }

  const nome_liberador = watch('nome_liberador')
  const nome_usuario = watch('nome_usuario')
  const data_inicio = watch('data_inicio')
  const data_fim = watch('data_fim')

  useEffect(() => {
    //só seta os valores se tiver valor
    if (nome_liberador) setValue('nome_liberador', nome_liberador)
    if (nome_usuario) setValue('nome_usuario', nome_usuario)
    if (data_inicio) setValue('data_inicio', data_inicio)
    if (data_fim) setValue('data_fim', data_fim)
  }, [searchParams, setValue, nome_liberador, nome_usuario, data_inicio, data_fim])

  const {
    data: history,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['history', searchParams],
    queryFn: () =>
      getHistory({
        nome_liberador,
        nome_usuario,
        data_inicio,
        data_final: data_fim,
      }),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  })

  console.log(history)

  return (
    <>
      <HeadingPages name="Controle Usuarios" />

      <Layout>
        <Filtros handleSubmit={handleSubmit} handleSearchValue={handleSearchValue} register={register} />
        <TableContainer>
          <T.Table>
            <T.Thead>
              <T.Tr>
                <T.Th>Nome Liberador</T.Th>
                <T.Th>Nome Usuário</T.Th>
                <T.Th>Data Liberação</T.Th>
                <T.Th>Motivo</T.Th>
                <T.Th>Tela</T.Th>
                <T.Th>Link</T.Th>
              </T.Tr>
            </T.Thead>
            <T.Tbody>
              {isLoading
                ? Array.from({ length: 5 }, (_, index) => (
                    <T.Tr key={index}>
                      {Array.from({ length: 6 }).map((_, index) => (
                        <T.TdSkeleton key={index} />
                      ))}
                    </T.Tr>
                  ))
                : history.map((user) => (
                    <T.Tr key={user.data_liberacao}>
                      <T.Td>{user.nome_liberador}</T.Td>
                      <T.Td>{user.nome_usuario}</T.Td>
                      <T.Td>{user.data_liberacao}</T.Td>
                      <T.Td>
                        <Tooltip label={user.motivo_liberacao} aria-label="A tooltip">
                          <Text maxW="200px" isTruncated mx="auto">
                            {user.motivo_liberacao}
                          </Text>
                        </Tooltip>
                      </T.Td>
                      <T.Td>{user.tela_ocorrencia}</T.Td>
                      <T.Td>
                        <Text
                          as="a"
                          href={user.link_ocorrencia}
                          isTruncated
                          _hover={{ textDecoration: 'underline' }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Acessar Tela
                        </Text>
                      </T.Td>
                    </T.Tr>
                  ))}
            </T.Tbody>
          </T.Table>
        </TableContainer>
      </Layout>
    </>
  )
}
